import * as firebase from 'firebase';


const settings = {};

const config = {
    apiKey: "AIzaSyBasyMlMz7CK_rVhVoFRIPVRBp_QBYzGv4",
    authDomain: "speyside-app-2ca69.firebaseapp.com",
    databaseURL: "https://speyside-app-2ca69.firebaseio.com",
    projectId: "speyside-app-2ca69",
    storageBucket: "speyside-app-2ca69.appspot.com",
    messagingSenderId: "488943930848"
  };
firebase.initializeApp(config);

firebase.firestore().settings(settings);

export default firebase;